import api from '../../utils/axios';

const clientReviewExpert = async (clientId, populate) => {
	const { data } = await api.get(
		`/client-review-experts?search[clientId]=${clientId}${
			populate ? '&populate=true' : ''
		}`
	);

	return data;
};

const clientReviewPlatform = async (clientId, populate) => {
	const { data } = await api.get(
		`/client-review-platforms?search[clientId]=${clientId}${
			populate ? '&populate=true' : ''
		}`
	);

	return data;
};

const createExpertReview = async (review) => {
	const { data } = await api.post(`/client-review-experts`, review);

	return data;
};

const createReviewStrengths = async (strengthId, clientReviewExpertId) => {
	return api.post(`/review-strengths`, {
		strengthId,
		clientReviewExpertId,
	});
};

const createPlatformReview = async (review) => {
	return await api.post(`/client-review-platforms`, review);
};

const deletePlatformReview = async (reviewId) => {
	return await api.delete(`/client-review-platforms/${reviewId}`);
};

const deleteExpertReview = async (reviewId) => {
	return await api.delete(`/client-review-experts/${reviewId}`);
};

const strengths = async () => {
	const { data } = await api.get(`/strengths`);

	return data;
};

const reviewStrengthsByclientReviewExpertID = async (clientReviewExpertId) => {
	const { data } = await api.get(
		`/review-strengths?search[clientReviewExpertId]=${clientReviewExpertId}`
	);

	return data;
};

const clientReviewService = {
	clientReviewExpert,
	clientReviewPlatform,
	createExpertReview,
	createPlatformReview,
	deletePlatformReview,
	deleteExpertReview,
	strengths,
	reviewStrengthsByclientReviewExpertID,
	createReviewStrengths,
};

export default clientReviewService;
